import React from "react";

/**
 * component svg
 */
const InfoIcon = function (props) {
    return(
        <svg version="1.1" id="info" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="0 0 1000 1000">
            <line className="st0-info" x1="500" y1="369" x2="500" y2="817"/>
            <circle className="st1-info" cx="500" cy="198" r="48"/>
        </svg>
    );
}

export default InfoIcon;